import { EyeOutlined } from "@ant-design/icons";
import { Affix, Button, Card, Space } from "antd";
import ListTable from "common/ListTable";
import { DISCARDED_DATA_LOGS } from "apiServices/API_ENDPOINTS";
import { getData } from "apiServices/common";
import { alertPop } from "apiServices/common/helper";
import { isMobileView } from "components/Common/AppHelper";
import BodyHeader from "components/Common/BodyHeader";
import CustomFilter from "components/Common/CustomFilter";
import Header from "components/Common/Header";
import { Fragment, useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function FailedItems(props) {
  // Props
  const { width } = props;

  // Router
  const location = useLocation();
  const routerPath = location ? location.pathname : null;
  const navigate = useNavigate();

  //   States
  const [showFilter, setShowFilter] = useState(
    localStorage.getItem("filter_status") && routerPath
      ? JSON.parse(localStorage.getItem("filter_status"))[routerPath]
      : false,
  );
  const [list, setList] = useState();
  const [totalData, setTotalData] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [rangeData, setRangeData] = useState();

  // Filter open/close status update in localStorage
  useEffect(() => {
    const filterStatus = localStorage.getItem("filter_status");
    const parsedFilterStatus = filterStatus ? JSON.parse(filterStatus) : {};

    if (showFilter) {
      parsedFilterStatus[routerPath] = true;
      localStorage.setItem("filter_status", JSON.stringify(parsedFilterStatus));
    } else {
      parsedFilterStatus[routerPath] = false;
      localStorage.setItem("filter_status", JSON.stringify(parsedFilterStatus));
    }
  }, [showFilter, routerPath, location]);

  const searchFilter = (values) => {
    console.log("values", values);
  };

  const columns = [
    {
      title: "Sync Date",
      dataIndex: "sync_date",
      key: ["po_maps", "original_po"],
    },
    {
      title: "Module Name",
      dataIndex: "module_name",
      key: "module_name",
    },

    {
      title: "Action",
      key: "action",
      width: "10%",
      render: (_, record) => {
        return (
          <Space>
            <Button
              size="small"
              type="primary"
              onClick={() => openForView(record)}
              icon={<EyeOutlined />}
              className="mr-2"
            >
              View
            </Button>
          </Space>
        );
      },
    },
  ];

  const getAll = async (passedObject) => {
    let filter = passedObject;
    setError(null);
    let response = await getData(DISCARDED_DATA_LOGS, false, filter);

    if (response && response?.status === 200) {
      let masterData = response?.data;
      setList(masterData?.data?.data);
      setTotalData(masterData?.data?.total);
      setRangeData(masterData?.data?.per_page);
    } else {
      alertPop(
        "error",
        response?.messages ? response?.messages : "Something Went Wrong!",
      );
      setError("Could not load this list.");
    }
    setLoading(false);
  };

  useEffect(() => {
    setLoading(true);
    getAll({ page: currentPage });
  }, [currentPage]);

  const openForView = ({ sync_date, module_name }) => {
    navigate(
      `/offline-sync-logs/failed-items/view/${sync_date}/${module_name}`,
    );
  };

  const paginate = (page) => {
    setCurrentPage(page);
  };

  const handleFilter = () => {
    setShowFilter((prev) => !prev);
  };

  const memoizedCustomFilter = useMemo(
    () => (
      <CustomFilter
        showFilter={showFilter}
        tableData={list}
        fetchTableData={getAll}
        filterName="failed_items"
      />
    ),
    [showFilter],
  );

  return (
    <Fragment>
      <Affix offsetTop={0}>
        <Card
          className="p-fixed"
          style={{ width: `${isMobileView() ? "100%" : `${width}px`}` }}
        >
          <Header
            title="Failed Items"
            subTitle=""
            actions={[
              <Button
                type={showFilter ? "danger" : "primary"}
                size="small"
                onClick={handleFilter}
                style={{ float: "right" }}
              >
                {`${showFilter ? "Close" : "Open"} Filter Option`}
              </Button>,
              // <Button
              //   key="3"
              //   size="small"
              //   type="primary"
              //   disabled={!hasPermission([EXPORT_DETAILS_CREATE_PERMISSION])}
              // >
              //   <Link to="/export/add-export-details">
              //     {hasPermission([EXPORT_DETAILS_CREATE_PERMISSION])
              //       ? "Add New"
              //       : "No Permission"}
              //   </Link>
              // </Button>,
            ]}
          ></Header>
        </Card>
      </Affix>

      <div className="containt-body">
        <Card>
          <BodyHeader searchFilter={searchFilter} />
          {memoizedCustomFilter}
          <ListTable
            loading={loading}
            error={error}
            onRetry={() => getAll({ page: currentPage })}
            emptyText="No records to show yet."
            dataSource={list}
            columns={columns}
            pagination={{
              showSizeChanger: false,
              current: currentPage,
              total: totalData,
              pageSize: rangeData,
              onChange: (page) => paginate(page),
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} of ${total} items`,
            }}
          />
        </Card>
      </div>
    </Fragment>
  );
}
